/**
 * 客服查询模块 API
 * 复用当前项目的 request 工具，自动注入 Authorization
 */
import { authStore } from "@/store/auth";
import { API_BASE_URL } from "@/utils/api";

const BASE = API_BASE_URL;

function authHeaders(extra = {}) {
  const h = { ...extra };
  if (authStore.state.token) {
    h["Authorization"] = "Bearer " + authStore.state.token;
  }
  return h;
}

async function fetchJson(url, options = {}) {
  const fullUrl = url.startsWith("http") ? url : BASE + url;
  const headers = authHeaders(options.headers);
  const res = await fetch(fullUrl, { ...options, headers });
  return res.json();
}

function buildQuery(params) {
  const q = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v != null && v !== "") q.set(k, String(v));
  }
  const s = q.toString();
  return s ? "?" + s : "";
}

/** 根据手机号查询用户 */
export function searchUsersByPhone(phones) {
  return fetchJson(`/v1/user/phones/user/info${buildQuery({ phone: phones })}`);
}

/** 签约订单 */
export function getAgreementOrders(userId) {
  return fetchJson(`/v1/balance/agreement/orders${buildQuery({ userId })}`);
}

/** 合利宝签约详情（用户交易卡绑定状态） */
export function getHelibaoAgreementStatus(externalAgreementNo) {
  return fetchJson(
    `/v1/yl/query/agreement/status${buildQuery({
      external_agreement_no: externalAgreementNo,
    })}`,
    { method: "GET" },
  );
}

/** 快钱签约详情（用户交易卡绑定状态） */
export function getKqAgreementStatus(externalAgreementNo) {
  return fetchJson(
    `/v1/kq/agreement/status/query${buildQuery({ externalAgreementNo })}`,
    { method: "GET" },
  );
}

/** 所有支付订单 */
export function getPaidOrders(userId) {
  return fetchJson(`/v1/balance/paid/orders${buildQuery({ userId })}`);
}

/** 退款记录 */
export function getRefundOrders(userId) {
  return fetchJson(`/v1/balance/refund/orders${buildQuery({ userId })}`);
}

/** 快钱订单查询（用于确认退款记录的处理结果） */
export function getKqPayStatus(tradeNo) {
  return fetchJson(
    `/v1/kq/pay/status/query${buildQuery({ tradeNo })}`,
    { method: "GET" },
  );
}

/** 合利宝退款查询，使用原付款订单号。 */
export function getHelibaoRefundStatus(outTradeNo) {
  return fetchJson(
    `/v1/yl/hlb/refund/status${buildQuery({ out_trade_no: outTradeNo })}`,
    { method: "GET" },
  );
}

/** 解约 */
export function unsignAgreement(externalAgreementNo) {
  return fetchJson(
    `/v1/balance/agreement/unsign${buildQuery({ externalAgreementNo })}`,
  );
}

/** 单笔退款 */
export function singleRefund(tradeNo) {
  return fetchJson("/v1/balance/single/refund", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ tradeNo, fullRefund: true }),
  });
}

/** Vidu 任务列表 */
export function getViduTasks(userId, pageIdx = 1, pageSize = 20) {
  return fetchJson(
    `/v1/ait2i/vd/task/list${buildQuery({ pageIdx, pageSize, allTask: 1 })}`,
    { headers: { userId: String(userId) } },
  );
}

/** 对口型任务列表 */
export function getLipSyncTasks(userId, pageIdx = 1, pageSize = 20) {
  return fetchJson(
    `/v1/chatgpt/cj/user/task/list${buildQuery({
      pageIdx,
      pageSize,
      allTask: 1,
    })}`,
    { headers: { userId: String(userId) } },
  );
}

/** 绘画任务列表 */
export function getDrawTasks(userId, pageIdx = 1, pageSize = 20) {
  return fetchJson(
    `/v1/ait2i/task/list${buildQuery({ pageIdx, pageSize, allTask: 1 })}`,
    { headers: { userId: String(userId) } },
  );
}

/** 根据订单编号查询用户 */
export function searchByOrderNo(orderNo) {
  return fetchJson(`/v1/balance/order/search${buildQuery({ orderNo })}`);
}

/** 根据支付时间范围查询用户 */
export function searchByPayTime(startTime, endTime) {
  return fetchJson(
    `/v1/balance/order/search/by-time${buildQuery({ startTime, endTime })}`,
  );
}

/** 算力总账户 */
export function getCreditAccount(userId) {
  return fetchJson("/v1/chatgpt/cj/user/credit/account", {
    headers: { userId: String(userId) },
  });
}

/** 算力变动记录 */
export function getCreditRecords(userId, pageIdx = 1, pageSize = 20) {
  return fetchJson(
    `/v1/chatgpt/cj/user/credit/list${buildQuery({ pageIdx, pageSize })}`,
    { headers: { userId: String(userId) } },
  );
}

/** 算力返还 */
export function returnCredit(userId, taskNo) {
  return fetchJson(
    `/v1/chatgpt/cj/user/credit/return${buildQuery({ taskNo })}`,
    { headers: { userId: String(userId) } },
  );
}

/** 算力赠送 */
export function grantCredit(userId, credit) {
  return fetchJson(
    `/v1/chatgpt/cj/user/credit/grant${buildQuery({ credit })}`,
    { headers: { userId: String(userId) } },
  );
}
